export const SMALL_RESOLUTION = 844;
export const LARGE_RESOLUTION = 1280;
export const MOBILE_RESOLUTION = 550;
